import React from 'react'
import styled from 'styled-components'
import { Text, Box, Icon } from 'components'

type Props = {
  textLabel?: string
  fieldIcon: string[] | string
  actionIcon: string[] | string
  handleClick: () => void
}

const CustomField: React.FC<Props> = ({ textLabel, fieldIcon, actionIcon, handleClick }) => (
  <BoxContainer>
    <Box
      border="1px solid"
      borderColor="gray4"
      borderRadius="4px"
      padding={20}
      marginBottom="8px"
      display="flex"
      alignItems="center"
      maxWidth="643px"
      onClick={handleClick}
    >
      <Icon mr="16px" color="gray5" icon={fieldIcon} />
      <Text fontSize={14} color="gray7">
        {textLabel}
      </Text>
      <StyledRightIconContainer>
        <Icon color="gray5" icon={actionIcon} />
      </StyledRightIconContainer>
    </Box>
  </BoxContainer>
)

const StyledRightIconContainer = styled.div`
  margin-left: auto;
`
const BoxContainer = styled.div`
  cursor: pointer;
`

export default CustomField
